import "./App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Gallery } from "./components/Gallery";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { WhyBook } from "./components/WhyBook";
import { Hours } from "./components/Hours";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { MobileBookBar } from "./components/MobileBookBar";

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Gallery />
        <About />
        <Services />
        <WhyBook />
        <Hours />
        <FinalCTA />
      </main>
      <Footer />
      <MobileBookBar />
    </div>
  );
}

export default App;
